// extracted by mini-css-extract-plugin
export default {"categoryManagement":"CategoryManagement_categoryManagement__wpqDS","title":"CategoryManagement_title__yKXhY","contentTitle":"CategoryManagement_contentTitle__G6jyH"};